import { PayloadAction } from '@reduxjs/toolkit';
import { pauseVideoSaga } from 'features/streaming/sagas/pauseVideoSaga';
import { RemoteTrackReceived } from 'features/streaming/types';
import { call, select } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { selectIsAudioOnlyMode } from 'features/application/applicationSlice';

export function* onRemoteTrackReceivedSaga(action: PayloadAction<RemoteTrackReceived>) {
  const { pluginHandle, track, mid } = action.payload;

  yield call(RTCClient.receivingFeed.addStreamTrack, pluginHandle, track, mid);

  if (track.kind === 'video') {
    const audioOnly: boolean = yield select(selectIsAudioOnlyMode);
    if (audioOnly) {
      yield call(pauseVideoSaga, mid);
    }
  }
}
